import React, { useEffect } from "react";
import { useState } from "react";
import useWindowResize from "../../hooks/useWindowResize";
import HeadCarousel from "../HeadCarousel/HeadCarousel";
import ScrollDown from "../ScrollDown/ScrollDown";
import styles from "./HeadPage.module.scss";
import ButtonWithIcon from "../ButtonWithIcon/ButtonWithIcon";

const HeadPage = ({
  location,
  title,
  subtitle,
  link,
  desc,
  breadcrumb,
  // image,
  // image_mobile,
  scrollToRef,
  carouselPictures,
  specificBrand = false,
}) => {
  const isMobile = useWindowResize(568);
  const isLarge = useWindowResize(1200);
  const [backgroundImage, setBackgroundImage] = useState("");
  const [carousel, setCarousel] = useState(false);
  const [moreHeight, setMoreHeight] = useState(null);
  const isBelowXL = useWindowResize(1200);
  const mobilePathIndex = breadcrumb?.path.length - 1;
  // const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (carouselPictures && carouselPictures.length == 1) {
      setBackgroundImage(
        isMobile
          ? carouselPictures[0].image_mobile.src
          : carouselPictures[0].image.src
      );
    }
  }, [isMobile, carouselPictures]);

  useEffect(() => {
    if (carouselPictures && carouselPictures.length > 1) {
      setCarousel(true);
      setMoreHeight(619);
    }
  }, [carouselPictures]);

  return (
    <div
      id="head-of-page"
      className={styles.HeadPage}
      style={{
        maxHeight: carousel ? "none" : !backgroundImage ? "290px" : null,
        height: carousel ? "auto" : null,
      }}
    >
      <div
        className={styles.container}
        style={
          !carousel
            ? {
                backgroundImage: `url(${backgroundImage})`,
                backgroundPosition: "top",
                backgroundSize: isMobile ? '338px' : 'auto',
                // maxWidth: "338px"
              }
            : null
        }
      >
        {carousel && <HeadCarousel listOfPictures={carouselPictures} />}
        <div
          className={styles.textContainer}
          style={{
            marginBottom: carousel
              ? "7rem"
              : !backgroundImage
              ? "10rem"
              : link || carousel || title?.split(" ").length > 1
              ? "8rem"
              : carousel && isBelowXL
              ? "4rem"
              : null,
            marginTop: carousel && isBelowXL ? "1rem" : null,
          }}
        >
          {location && (
            <div className={styles.location}>{location.toUpperCase()}</div>
          )}
          {title && (
            <div
              className={styles.title}
              style={{
                fontSize: specificBrand ? "3.125rem" : null,
                height: "fit-content",
              }}
            >
              <div
                className="title"
                dangerouslySetInnerHTML={{ __html: title }}
                // style={{ display: loaded ? null : "none" }}
              />
            </div>
          )}
          <div
            className={styles.breadcrumb}
            style={{
              display: isBelowXL ? "none" : null,
              bottom: carouselPictures ? "80px" : !backgroundImage && "30px",
            }}
          >
            {breadcrumb?.path.map((d, i) => (
              <div key={i}>
                <a key={i} href={d.url}>
                  <span>
                    {d.title}
                    {" >"}
                  </span>
                </a>
              </div>
            ))}
            <div className={styles.address}>{breadcrumb?.currentPage}</div>
          </div>
          <div
            className={styles.breadcrumb}
            style={{ display: isBelowXL ? null : "none" }}
          >
            {"< "}
            <a
              className={styles.address}
              href={breadcrumb?.path[mobilePathIndex].url}
            >
              {breadcrumb?.currentPage}
            </a>
          </div>
          {subtitle && (
            <div
              className={styles.subtitle}
              dangerouslySetInnerHTML={{ __html: subtitle }}
            ></div>
          )}
          {link && (
            <div className={styles.link}>
              <ButtonWithIcon link={link} outline={false} lightGold />
            </div>
          )}
          {desc && <div className={styles.desc}>{desc}</div>}
        </div>
        {scrollToRef && carouselPictures && (
          <div style={{ display: specificBrand ? "none" : "block" }}>
            <ScrollDown selector={scrollToRef} height={moreHeight} />
          </div>
        )}
      </div>
    </div>
  );
};

export default HeadPage;
